"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useCounter_1 = require("./useCounter");
exports.default = useCounter_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useNumber.js
// module id = 1220
// module chunks = 17